// Copyright (c) 2016 Deere & Company

import KeyValuePair from '@deere/cps-it.warranty-model-factory/lib/key-value-pair';
import t from 'tcomb';

const ServiceIntervalTypes = t.list(KeyValuePair, 'ServiceIntervalTypes');

export const getDefaultState = () => new ServiceIntervalTypes([]);

export default ServiceIntervalTypes;



// WEBPACK FOOTER //
// ./src/reports/maintenance-plan/state/service-interval-types.js